export default "__VITE_ASSET__DtCEZPxj__"